import { useState, useCallback, useEffect } from 'react';
import { caySamApiService } from 'src/api/caysam-api';
import { CaySam } from 'src/types/caysam';
import useCaySamFilterOptions from 'src/utils/use-caysam-filter-options';

export type FeaturedItem = {
  id: string;
  title: string;
  description: string;
  coverUrl: string;
  vuonTrong_ID?: string;
  losam_ID?: string;
  trangThai?: string;
  soLa?: number;
  diemSucKhoe?: string;
  tenLo?: string,
  tenVuong?:string,
};

export default function useFeaturedCaySam() {
  const [featuredList, setFeaturedList] = useState<FeaturedItem[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { getTrangThaiText,getTuoiText,getSucKhoeText } = useCaySamFilterOptions();

const getFeaturedCaySams = useCallback(async () => {
    // Không cho phép chạy nếu đang load để tránh chồng chéo request
    setLoading(true);
    setError(null);
    try {
      const response = await caySamApiService.getCaySamByUser();

      if (response.messCode === 1) {
        const items = Array.isArray(response.items) ? (response.items as CaySam[]) : [];

        const formattedData: FeaturedItem[] = items.map((item) => {
          let imageUrl = 'https://api-prod-minimal-v510.vercel.app/assets/images/cover/cover_1.jpg';
          const firstLog = item.caySamNhatKys?.[0];

          if (firstLog) {
            imageUrl = firstLog.hinhAnhTongQuan || firstLog.hinhAnhChiTiet || imageUrl;
          } else if (item.loSam?.hinhAnh) {
            imageUrl = item.loSam.hinhAnh;
          }

          return {
            id: String(item.caySam_ID), 
            title: item.maCaySam ? `Sâm Ngọc Linh - ${item.maCaySam}` : 'Sâm Ngọc Linh',
            vuonTrong_ID: item.loSam?.vuonTrong?.vuonTrong_ID ? String(item.loSam.vuonTrong.vuonTrong_ID) : undefined,
            losam_ID: item.loSam?.loSam_ID ? String(item.loSam.loSam_ID) : undefined,
            tenLo: item.loSam?.tenLo,
            tenVuong: item.loSam?.vuonTrong?.diaChi,
            // Sử dụng các hàm từ hook bên ngoài
            tuoiCay: getTuoiText(item.tuoiCay_ID),
            trangThai: getTrangThaiText(firstLog?.tinhTrang),
            diemSucKhoe: getSucKhoeText(firstLog?.diemSucKhoe),
            soLa: firstLog?.soLa,
            description: `Mã lô: ${item.loSam?.loSam_ID || 'N/A'}`, 
            coverUrl: imageUrl, 
          };
        });

        setFeaturedList(formattedData.slice(0, 5));
      }
    } catch (err: any) {
      setError(err.message || 'Không thể tải dữ liệu');
    } finally {
      setLoading(false);
    }
    // QUAN TRỌNG: Để mảng rỗng [] nếu bạn chắc chắn getTrangThaiText/getTuoiText 
    // không thay đổi logic theo state của component này.
  }, []); // eslint-disable-line react-hooks/exhaustive-deps 

  useEffect(() => {
    getFeaturedCaySams();
  }, [getFeaturedCaySams]);

  return {
    featuredList,
    loading,
    error,
    refresh: getFeaturedCaySams,
  };
}
